export enum AlertDisplayMode {
    Inline = 'inline',
    Modal = 'modal'
}

export interface AlertOptions {
    title?: string;
    duration?: number;
    showAfterRouteChange?: boolean;
    isDismissible?: boolean;
    /**
     * Target identifier specifies which alert component should display this alert.
     * Examples: 'page-header', 'form-footer', 'payment-modal'
     * If not provided, alert is displayed by default handlers (based on displayMode).
     */
    target?: string;
    /**
     * Display mode: 'inline' for inline alerts, 'modal' for popup alerts.
     * Accepts either the AlertDisplayMode enum or the literal string values used in settings.
     * If not provided, defaults based on env.IS_MOBILE_APP (mobile => 'modal', web => 'inline').
     */
    displayMode?: AlertDisplayMode | 'inline' | 'modal';
}

export interface AlertState extends AlertOptions {
    id?: string;
    type: AlertType;
    message: string;
    /**
     * Internal resolved displayMode used for filtering alerts in selectors.
     * Do not set directly; it is computed from target + env default.
     */
    displayMode?: AlertDisplayMode;
}

export enum AlertType {
    Success = 'Success',
    Error = 'Error',
    Info = 'Info',
    Warning = 'Warning'
}
